var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSelCnt)?_c('div',{staticClass:"ur-data-grid__info-item ur-data-grid__action__selected-cnt"},[_c('ur-icon',{attrs:{"icon":"checked","iconType":"picto"}}),_vm._v(_vm._s(_vm.selText)+"\n")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }